import { ChangeDetectionStrategy, Component, ElementRef, inject, Inject, Pipe, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SelectUsersInputComponent } from 'src/app/features/users/components/select-users-input/select-users-input.component';
import { UsersStore } from '../../users-store';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { User } from 'src/app/models/user.model';
import { GlobalStore } from 'src/app/store/global-store';
import { EmailBodyComponent } from '../email-body/email-body.component';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MailForm } from 'src/app/models/mailForm';
import { Reminder } from 'src/app/models/reminder';
import { QuestionnaireCategory } from 'src/app/models/questionnaireCategory.model';
import { combineLatest, map, startWith, Subject, tap } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { Recipient, Recipients } from 'src/app/models/recipients.model';
import { DistributionGroup } from 'src/app/models/distribution-group.model';
import { MiniContactDisplayComponent } from '../mini-contact-display/mini-contact-display.component';
import { ContactDisplayComponent } from '../contact-display/contact-display.component';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { DistributionGroupSquareComponent } from 'src/app/features/questionnaires/features/table-grid/features/questionnaire-data/components/distribution-group-square/distribution-group-square';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';

@Component({
    imports: [CommonModule, TranslateDirective, TranslatePipe, MiniContactDisplayComponent, ContactDisplayComponent, ReactiveFormsModule, MatAutocompleteModule,
        DistributionGroupSquareComponent, OverlayModule, SelectUsersInputComponent, MatSelectModule
    ],
    providers: [UsersStore],
    templateUrl: './create-distribution-group.html',
    styleUrls: ['./create-distribution-group.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateDistributionGroupComponent {

  @ViewChild('colorInput') colorInput: ElementRef | undefined;
  isCreate = false;
  constructor(@Inject(MAT_DIALOG_DATA) private readonly data: { editGroup?: DistributionGroup, isCreate?: boolean },
    private readonly dialogRef: MatDialogRef<CreateDistributionGroupComponent>) {
    if (data?.editGroup?.users) {
      data.editGroup.users?.forEach(u => this.#usersStore.addRecipient(u));
    }
    if(data?.isCreate){
      this.isCreate=true;
    }
  }

  readonly positonArea = [{
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
  }] as ConnectedPosition[];

  isSelectColorOpen = true;
  #usersStore = inject(UsersStore);
  #globalStore = inject(GlobalStore);
  myControl = new FormControl<string>('');
  groupName = new FormControl<string>(this.data?.editGroup?.name ? this.data.editGroup?.name : '', Validators.required);
  color = new FormControl(this.data?.editGroup?.color);
  groupType = new FormControl<number>(this.data?.editGroup?.groupType ?? 1);
  groupTypes$ = toSignal(this.#globalStore.groupTypes$);
  maxOptionsToShow = 5;
  chosenRecipients = toSignal(this.#usersStore.choosenRecipient$);
  isRecipients$ = toSignal(this.#usersStore.isRecipients$);
  users$ = combineLatest(([this.#usersStore.usersWithoutChoosen$, this.myControl.valueChanges.pipe(startWith(''))])).pipe(
    map(([users, value]) => users.map(user => { return { ...user, fullName: ` ${user.firstName} ${user.lastName} ` } })
      .filter(x => {
        var lowerValue = "";
        if (value != '' && value && typeof value === 'string') {
          lowerValue = value?.toLocaleLowerCase();
        }
        return x.fullName?.toLocaleLowerCase().includes(lowerValue) || x?.email?.toLocaleLowerCase().includes(lowerValue ?? '')
      })));
  recipients$ = this.#usersStore.recipient$;

  onContactSelected(event: MatAutocompleteSelectedEvent): void {
    const selectedOption = event.option.value;
    this.myControl.setValue('');
    this.#usersStore.addRecipient(selectedOption);
  }
  close() {
    this.dialogRef.close();
  }
  cancel() {
    this.dialogRef.close();
  }
  save() {
    this.dialogRef.close([this.groupName.value, this.chosenRecipients()?.users?.map(x => x.user), this.color.value, this.groupType.value]);
  }
  // SelectColor(){
  //   this.isSelectColorOpen=true;
  //   if(this.colorInput)
  //   {
  //     this.colorInput.nativeElement.click();
  //   }
  // }
}
